import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { AuthServiceTESS } from './core/services/auth.service';
import { AuthServiceForgerock } from './core/services/auth-service.service';
import { AuthGuardService } from './core/services/auth-guard.service';
import { UnauthorizedComponent } from './core/components/unauthorized/unauthorized.component';
import { CanDeactivateService } from './core/services/can-deactivate.service';

const routes: Routes = [ 
  {
    path:  'wl',
    loadChildren: () => import('./feature/writeups-leads/writeups-leads.module').then(m => m.WriteupsLeadsModule),
    canActivate : [AuthGuardService],
    canActivateChild : [AuthGuardService],
  },
  {
    path: '',
    redirectTo: 'wl',
    pathMatch: 'full'
  },
  {
    path: 'unauthorized',
    component: UnauthorizedComponent 
     
  },
  {
    path:  'wd',
    loadChildren: () => import( './feature/writeups-detail/writeups-detail.module').then(m => m.WriteupDetailModule),
    canActivate : [AuthGuardService],
    canActivateChild : [AuthGuardService],
    canDeactivate: [CanDeactivateService]
     
  },
  {
    path:  'cs',
    loadChildren: () => import('./feature/customer-summary/customer-summary.module').then(m => m.CustomerSummaryModule),
    canActivate : [AuthGuardService],
    canActivateChild : [AuthGuardService],
   },
  {
    path: 'cv',
    loadChildren: ()=> import("./feature/customer-view/customer-view.module").then(m => m.CustomerViewModule),
    canActivate : [AuthGuardService],
    canActivateChild : [AuthGuardService],
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot( routes, { useHash: false, preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule],
  providers: [
    AuthGuardService,
    AuthServiceForgerock,
    AuthServiceTESS,
    CanDeactivateService
  ]
})
export class AppRoutingModule { }
